import React from "react";
import Flagship from "../../core/flagship";
import * as actions from "../../actions/appActions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Loader,
  Segment,
  Header,
  Button,
  Icon,
  Label,
  Table,
  Popup,
  Image,
  Dropdown
} from "semantic-ui-react";
import moment from "moment-business-days";
import "../../styles/timeTracking.scss";
import { Link } from "react-router";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { empty } from "../../utils/helpers";
import TimeEntryEditModal from "../modals/TimeEntryEditModal";

class TimeListView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      startDate: moment().subtract(1, "week"),
      endDate: null,
      loading: true,
      expandedLoading: false,
      breakdown: "entry",
      search: null,
      expanded: false,
      expandedData: [],
      reportData: {},
      timeTotal: 0,
      editingEntry: false
    };

    this.getReport = this.getReport.bind(this);
    this.getExpanded = this.getExpanded.bind(this);
    this.renderTimeEntry = this.renderTimeEntry.bind(this);
    this.onChangeStartDate = this.onChangeStartDate.bind(this);
    this.onChangeEndDate = this.onChangeEndDate.bind(this);
    this.onChangeBreakdown = this.onChangeBreakdown.bind(this);
    this.onChangeReportSearch = this.onChangeReportSearch.bind(this);
    this.editEntry = this.editEntry.bind(this);
    this.usePreviousTimesheet = this.usePreviousTimesheet.bind(this);
    this.updateEntry = this.updateEntry.bind(this);
    this.deleteEntry = this.deleteEntry.bind(this);
    this.expand = this.expand.bind(this);
    this.updateAllData = this.updateAllData.bind(this);
    this.renderSearch = this.renderSearch.bind(this);
    this.renderCollection = this.renderCollection.bind(this);
    this.renderIndividualEntries = this.renderIndividualEntries.bind(this);
  }

  componentWillMount() {
    setTimeout(Flagship.closeSidebarNav, 500);
    this.getReport();
  }

  componentDidMount() {
    document.title = "Flagship / Time Entries";
  }

  componentDidUpdate(prevProps) {
    if (prevProps.userId !== this.props.userId) {
      this.getReport();
    }
  }

  updateAllData() {
    let self = this;
    if (this.state.expanded === false) {
      this.setState(
        {
          loading: true,
          reportData: {}
        },
        function() {
          self.getReport();
        }
      );
    } else {
      this.setState(
        {
          expandedLoading: true,
          expandedData: []
        },
        function() {
          self.getExpanded();
        }
      );
    }
  }

  expand(identifier, name) {
    let self = this;
    this.setState(
      {
        expanded: {
          identifier,
          name
        },
        expandedLoading: true
      },
      function() {
        self.getExpanded();
      }
    );
  }

  onChangeStartDate(date) {
    let self = this;

    if (
      !empty(date) &&
      !empty(this.state.endDate) &&
      this.state.endDate !== null
    ) {
      if (moment(this.state.endDate).isAfter(date)) {
        this.setState(
          {
            startDate: date
          },
          self.updateAllData
        );
      } else {
        Flagship.notify("Invalid date range.", "error");
      }
    } else {
      this.setState(
        {
          startDate: date
        },
        self.updateAllData
      );
    }
  }

  onChangeEndDate(date) {
    let self = this;

    if (
      !empty(date) &&
      !empty(this.state.startDate) &&
      this.state.startDate !== null
    ) {
      if (moment(date).isAfter(this.state.startDate)) {
        this.setState(
          {
            endDate: date
          },
          self.updateAllData
        );
      } else {
        Flagship.notify("Invalid date range.", "error");
      }
    } else {
      this.setState(
        {
          endDate: date
        },
        self.updateAllData
      );
    }
  }

  onChangeBreakdown(e, data) {
    let self = this;
    this.setState(
      {
        breakdown: data.value,
        search: null
      },
      function() {
        self.getReport();
      }
    );
  }

  onChangeReportSearch(e, data) {
    this.setState({
      search: data.value
    });
  }

  getExpanded() {
    let self = this;

    Flagship.get(
      "timesheets/" +
        this.state.breakdown +
        "/" +
        this.state.expanded.identifier,
      {
        startDate:
          this.state.startDate !== null
            ? this.state.startDate.format("YYYY-MM-DD")
            : null,
        endDate:
          this.state.endDate !== null
            ? this.state.endDate.format("YYYY-MM-DD")
            : null,
        limitToUser: this.props.userId
      },
      function(response) {
        if (response.data.success === true) {
          self.setState({
            timeTotal: response.data.time_total,
            expandedData: response.data.results,
            expandedLoading: false
          });
        } else {
          Flagship.error(
            "Failed to retrieve " +
              self.state.breakdown +
              " time report for range.",
            0,
            self.props.userId
          );
        }
      },
      function(err) {
        Flagship.error(
          "Failed to retrieve " +
            self.state.breakdown +
            " time report for range: " +
            err,
          0,
          self.props.userId
        );
      }
    );
  }

  getReport() {
    let self = this;

    let endpoint = "timesheets/report/" + this.state.breakdown;
    let query = {
      startDate:
        this.state.startDate !== null
          ? this.state.startDate.format("YYYY-MM-DD")
          : null,
      endDate:
        this.state.endDate !== null
          ? this.state.endDate.format("YYYY-MM-DD")
          : null,
      limitToUser: this.props.userId
    };

    if (this.state.breakdown === "entry") {
      endpoint = "/timesheets/user/" + this.props.userId;
      query = {
        startDate:
          this.state.startDate !== null
            ? this.state.startDate.format("YYYY-MM-DD")
            : null,
        endDate:
          this.state.endDate !== null
            ? this.state.endDate.format("YYYY-MM-DD")
            : null
      };
    }

    Flagship.get(
      endpoint,
      query,
      function(response) {
        if (response.data.success === true) {
          self.setState({
            timeTotal: response.data.time_total,
            reportData: response.data.results,
            loading: false
          });
        } else {
          Flagship.error(
            "Failed to retrieve " +
              self.state.breakdown +
              " time report for range.",
            0,
            self.props.userId
          );
        }
      },
      function(err) {
        Flagship.error(
          "Failed to retrieve " +
            self.state.breakdown +
            " time report for range: " +
            err,
          0,
          self.props.userId
        );
      }
    );
  }

  editEntry(entry) {
    this.setState({
      editingEntry: entry
    });
  }

  usePreviousTimesheet(entry) {
    this.props.actions.usePreviousTimesheet(entry);
  }

  deleteEntry(entry) {
    let self = this;

    Flagship.post(
      "timesheets/delete/" + entry.id,
      {},
      function(response) {
        if (response.data.success === true) {
          self.getReport();
          Flagship.notify("Time entry deleted.", "info");
          self.setState({
            editingEntry: false
          });
        } else {
          Flagship.error(
            "Failed to delete time entry.",
            entry.id,
            self.props.userId
          );
        }
      },
      function(err) {
        Flagship.error(
          "Failed to delete time entry: " + err,
          entry.id,
          self.props.userId
        );
      }
    );
  }

  updateEntry(entry) {
    let self = this;

    Flagship.post(
      "timesheets/update/" + entry.id,
      {
        client: entry.client.id,
        user: this.props.userId,
        hours: entry.hours,
        task: entry.task,
        date: moment(entry.date).format("YYYY-MM-DD"),
        notes: entry.notes
      },
      function(response) {
        if (response.data.success === true) {
          if (self.state.breakdown === "entry") {
            self.getReport();
          } else {
            self.getExpanded();
          }
          Flagship.notify("Time entry updated.", "success");
          self.setState({
            editingEntry: false
          });
        } else {
          Flagship.error(
            "Failed to update time entry.",
            entry.client.id,
            self.props.userId
          );
        }
      },
      function(err) {
        Flagship.error(
          "Failed to update time entry: " + err,
          entry.client.id,
          self.props.userId
        );
      }
    );
  }

  renderTimeEntry(entry, i) {
    return (
      <Table.Row key={i}>
        <Table.Cell>{parseFloat(entry.hours).toFixed(2)}</Table.Cell>
        <Table.Cell>
          <Popup
            trigger={
              <Image
                src={Flagship.config.uploads + entry.photo}
                style={{ cursor: "pointer" }}
                avatar
                as={Link}
                to={"/user/view/" + entry.user}
                target="_blank"
              />
            }
          >
            {entry.first_name + " " + entry.last_name}
          </Popup>
        </Table.Cell>
        <Table.Cell>
          <Label color="teal">{entry.task}</Label>
        </Table.Cell>
        <Table.Cell>{entry.record_name}</Table.Cell>
        <Table.Cell>
          <Label>
            {entry.instance !== "Standard" ? entry.instance : entry.market}
          </Label>
        </Table.Cell>
        <Table.Cell>
          <em>{moment(entry.date, "YYYY-MM-DD").format("MM/DD/YY")}</em>
        </Table.Cell>
        <Table.Cell style={{ minWidth: "210px" }}>
          <Button
            style={{ display: "inline-block" }}
            size="small"
            onClick={() => {
              this.editEntry(entry);
            }}
          >
            Edit
          </Button>
          <Button
            size="small"
            style={{
              width: "100px",
              color: "#ffffff",
              display: "inline-block",
              padding: ".78571429em 1.0em .78571429em"
            }}
            color="black"
            as={Link}
            onClick={() => this.usePreviousTimesheet(entry)}
            to={"/time/date/" + moment().format("MM-DD-YYYY") + "/add/previous"}
          >
            Use again
          </Button>
        </Table.Cell>
      </Table.Row>
    );
  }

  renderCollection(afterHeadingText) {
    let self = this;

    let output = [];

    for (const [key, entry] of Object.entries(this.state.reportData)) {
      let headingText = key !== "all" ? key : "My Entries";

      output.push(
        <Segment className="time-tracking-entry" key={key}>
          <Table celled striped>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>
                  <span className="time-report-before-heading-text">
                    {headingText}
                  </span>
                  {afterHeadingText}
                </Table.HeaderCell>
                <Table.HeaderCell>
                  <span
                    key="total-hours-top"
                    style={{
                      display: "inline-block",
                      marginRight: "2.5em",
                      verticalAlign: "middle"
                    }}
                  >
                    {parseFloat(entry.time).toFixed(2)} Total Hours
                  </span>
                  <Button
                    size="small"
                    floated="right"
                    style={{ marginBottom: "-5px", marginTop: "-5px" }}
                    as={Link}
                    to={"/time/date/" + moment().format("MM-DD-YYYY") + "/add"}
                    color="teal"
                  >
                    <Icon name="clock" />
                    Add Time...
                  </Button>
                </Table.HeaderCell>
                <Table.HeaderCell>Percent Total</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {typeof entry.data !== "undefined" && entry.data.length > 0 ? (
                self.renderRows(key)
              ) : (
                <Table.Row>
                  <Table.Cell>Nothing found for specified range.</Table.Cell>
                </Table.Row>
              )}
            </Table.Body>
            <Table.Footer>
              <Table.Row>
                <Table.HeaderCell colSpan={3}>
                  <strong>
                    {parseFloat(entry.time).toFixed(2)} Total Hours Recorded
                  </strong>
                </Table.HeaderCell>
              </Table.Row>
            </Table.Footer>
          </Table>
        </Segment>
      );
    }
    return output;
  }

  renderIndividualEntries(afterHeadingText) {
    let self = this;
    let data =
      this.state.breakdown === "entry"
        ? this.state.reportData
        : this.state.expandedData;

    return (
      <Segment className="time-tracking-entry">
        {this.state.expandedLoading ? (
          <div>
            <Loader className="flagship-loader" active={true} inline />
          </div>
        ) : (
          <Table celled striped>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell
                  colSpan="7"
                  className="timesheet-report-expanded-heading"
                >
                  Time Entries {afterHeadingText}
                  {this.state.breakdown === "entry" ? (
                    [
                      <Button
                        size="small"
                        key="add-time-btn"
                        floated="right"
                        as={Link}
                        to={
                          "/time/date/" + moment().format("MM-DD-YYYY") + "/add"
                        }
                        color="teal"
                      >
                        <Icon name="clock" />
                        Add Time...
                      </Button>,
                      <span
                        className="float-right"
                        key="total-hours-top"
                        style={{
                          display: "inline-block",
                          marginRight: "2.5em"
                        }}
                      >
                        {parseFloat(this.state.timeTotal).toFixed(2)} Total
                        Hours
                      </span>
                    ]
                  ) : (
                    <Button
                      className="float-right"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        this.setState({ expanded: false }, this.getReport);
                      }}
                    >
                      <Icon name="left arrow" />
                      Back to All
                    </Button>
                  )}
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {data.length > 0 ? (
                data.map(function(entry, i) {
                  let rendered = self.renderTimeEntry(entry, i);
                  if (empty(entry.notes)) {
                    return rendered;
                  } else {
                    return (
                      <Popup
                        key={i}
                        trigger={rendered}
                        content={entry.notes}
                        position="bottom left"
                        inverted
                        className="time-entry-notes-popup"
                      />
                    );
                  }
                })
              ) : (
                <Table.Row>
                  <Table.Cell collapsing>
                    No time entries for this range.
                  </Table.Cell>
                </Table.Row>
              )}
            </Table.Body>
            <Table.Footer fullWidth>
              <Table.Row>
                <Table.HeaderCell>
                  <strong>{parseFloat(this.state.timeTotal).toFixed(2)}</strong>
                </Table.HeaderCell>
                <Table.HeaderCell colSpan="6">
                  Total Hours Recorded {afterHeadingText}
                </Table.HeaderCell>
              </Table.Row>
            </Table.Footer>
          </Table>
        )}
      </Segment>
    );
  }

  renderRows(dimension) {
    let self = this;
    let collection = this.state.reportData[dimension];

    return collection.data.map(function(entry) {
      let imageProps = null;

      if (!empty(entry.photo)) {
        imageProps = {
          avatar: true,
          spaced: "right",
          src: Flagship.config.uploads + entry.photo
        };
      }

      return self.state.search === entry.name || self.state.search === null ? (
        <Table.Row key={entry.id}>
          <Table.Cell>
            <Label
              className="label-avatar"
              content={entry.name}
              image={imageProps}
              style={{ cursor: "pointer" }}
              onClick={() => {
                self.expand(entry.id, entry.name);
              }}
            />
          </Table.Cell>
          <Table.Cell>{parseFloat(entry.time).toFixed(2)}</Table.Cell>
          <Table.Cell>
            {(
              (parseFloat(entry.time) /
                parseFloat(self.state.reportData[dimension]["time"])) *
              100
            ).toFixed(1) + "%"}
          </Table.Cell>
        </Table.Row>
      ) : null;
    });
  }

  renderSearch() {
    if (this.state.breakdown !== "entry") {
      let searchOptions = [];
      if (typeof this.state.reportData.all !== "undefined") {
        for (const item of this.state.reportData.all.data) {
          searchOptions.push({ value: item.name, text: item.name });
        }
      } else if (typeof this.state.reportData === "object") {
        Object.keys(this.state.reportData).map(function(text) {
          searchOptions.push({ value: text, text });
        });
      }
      return (
        <Dropdown
          search
          icon={null}
          key="search-report-dropdown"
          className="search-report"
          onChange={this.onChangeReportSearch}
          options={[{ text: "Clear...", value: null }, ...searchOptions]}
          placeholder={"Specific " + this.state.breakdown + "..."}
          value={this.state.search}
        />
      );
    }
    return null;
  }

  render() {
    let reportHeading = this.state.expanded
      ? this.state.expanded.name
      : "My Hours ";
    let afterHeadingText = "Time Recorded";

    if (this.state.startDate === null && this.state.endDate === null) {
      afterHeadingText = " So Far This Month";
    } else if (this.state.startDate === null) {
      afterHeadingText = " Through " + this.state.endDate.format("MM/DD/YY");
    } else if (this.state.endDate === null) {
      afterHeadingText =
        " Since " + moment(this.state.startDate).format("MM/DD/YY");
    } else {
      afterHeadingText =
        " Between " +
        this.state.startDate.format("MM/DD/YY") +
        " - " +
        this.state.endDate.format("MM/DD/YY");
    }

    if (this.state.loading === false) {
      let primaryOptions = [
        { text: "By Entry", value: "entry" },
        { text: "By Market", value: "market" },
        { text: "By Client", value: "client" },
        { text: "By Category", value: "category" }
      ];

      return (
        <Segment.Group>
          <Segment>
            <Header>
              {reportHeading}
              {this.state.expanded ? (
                <span> - Individual Entries</span>
              ) : (
                [
                  <Dropdown
                    key="primary-dimension-dropdown"
                    onChange={this.onChangeBreakdown}
                    options={primaryOptions}
                    placeholder="Select Breakdown..."
                    value={this.state.breakdown}
                  />,
                  this.renderSearch()
                ]
              )}
              <div className="time-report-filters">
                <DatePicker
                  className="time-report-date-selector start-date"
                  placeholder="Start Date"
                  selected={this.state.startDate}
                  placeholderText="Start Date"
                  startDate={this.state.startDate}
                  endDate={this.state.endDate}
                  maxDate={this.state.endDate}
                  onChange={this.onChangeStartDate}
                />
                <span style={{ marginRight: ".5em" }}> - </span>
                <DatePicker
                  className="time-report-date-selector end-date"
                  placeholderText="End Date"
                  selected={this.state.endDate}
                  startDate={this.state.startDate}
                  endDate={this.state.endDate}
                  minDate={
                    !empty(this.state.startDate) ? this.state.startDate : null
                  }
                  onChange={this.onChangeEndDate}
                />
              </div>
            </Header>
          </Segment>
          {this.state.expanded === false && this.state.breakdown !== "entry"
            ? this.renderCollection(afterHeadingText)
            : this.renderIndividualEntries(afterHeadingText)}
          <TimeEntryEditModal
            open={this.state.editingEntry !== false}
            cancelEdit={() => {
              this.editEntry(false);
            }}
            {...this.state.editingEntry}
            onUpdateEntry={this.updateEntry}
            onDeleteEntry={this.deleteEntry}
          />
          <div style={{ margin: "1em 0 2em" }}>
            <Link className="white-text" to={"/time/"}>
              <Icon name="calendar" />
              Calendar View
            </Link>
          </div>
        </Segment.Group>
      );
    } else {
      return (
        <div>
          <Loader className="flagship-loader" active={true} inline />
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    token: state.main.token,
    username: state.main.username,
    firstName: state.main.userFirstName,
    userRole: state.main.userRole,
    userId: state.main.userId
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TimeListView);



// WEBPACK FOOTER //
// ./src/components/views/TimeListView.js